/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Requestaskedon2Inputs */

const en_requestaskedon2 = /** @type {(inputs: Requestaskedon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Asked on ${i?.date}`)
};

const de_requestaskedon2 = /** @type {(inputs: Requestaskedon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Angefragt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Asked on {date}" |
*
* @param {Requestaskedon2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestaskedon2 = /** @type {((inputs: Requestaskedon2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestaskedon2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestaskedon2(inputs)
	return de_requestaskedon2(inputs)
});
export { requestaskedon2 as "requestAskedOn" }